import React, { createContext, useState, useEffect } from 'react';
import decode from 'jwt-decode'
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import axios from "axios";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import Password from "../layout/Login/Password";


export const AuthContext = createContext();

const AuthContextProvider = (props) => {  
  const [token, setToken] = useState('')
  const [isAuth, setIsAuth] = useState(false)
  const [user, setUser] = useState({})

  const loginUser = (token)=>{
    localStorage.setItem('app_token', token)
    localStorage.setItem('tema', "white-content")
    const decoded = decode(token)
    setToken(token)
    setIsAuth(true)
    setUser(decoded)
  }

  // Cambia el token sin tocar nada mas (renovacion o cambio de contrasena)
  const aplicaToken = (nuevo)=>{
    localStorage.setItem('app_token', nuevo)
    setToken(nuevo)
    setUser(decode(nuevo))
  }

  const logoutUser = (user)=>{
    localStorage.removeItem('app_token')
    setToken({})
    setIsAuth(false)
    setUser(null)
  }

  const salir =()=>{
    const token = localStorage.getItem('app_token')
    let dateNow = Math.floor(Date.now()/1000)
    const decoded = decode(token)
    let timexp = decoded.exp
    if (dateNow >= timexp){
      localStorage.removeItem('app_token')
      setToken({})
      setIsAuth(false)
      setUser(null)
      Swal.fire({
        position: "center",
        icon: "success",
        title: "Tu sesion ha caducado",
        showConfirmButton: false,
        timer: 2000,
      });
      setTimeout(() => {
        window.location.href = '/login'
      }, 1000);
    }
  }
  

  // D03 (checklist 21 OCT): al abrir el sistema se piden los permisos vigentes.
  // Asi un cambio de permisos o una baja aplican al volver a entrar, sin tener
  // que cerrar sesion. Si falla la red se queda con el token que ya tenia.
  function renovar() {
    if (!localStorage.getItem('app_token')) return
    axios
      .get(`${process.env.REACT_APP_URL_USERS}Renovar`, {
        headers: { Authorization: `Bearer: ${localStorage.getItem('app_token')}` },
      })
      .then((res) => {
        if (res.data && res.data.token) aplicaToken(res.data.token)
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          logoutUser()
          Swal.fire({ icon: "info", title: "Tu sesion ya no es valida", text: error.response.data?.message || "" })
          setTimeout(() => { window.location.href = '/login' }, 1500)
        }
      })
  }

  useEffect(()=>{
    const item = localStorage.getItem('app_token')
    if (item){
      const decoded = decode(item)
      setToken(item)
      setIsAuth(true)
      setUser(decoded)
      salir()
      renovar()
    }
  }, [])

  return (
        <AuthContext.Provider
      value={{
        token,
        isAuth,
        user,
        loginUser,
        logoutUser,
        aplicaToken,
      }}
      >
      { props.children }
      {/* D04: contrasena temporal (la puso otra persona): no se puede seguir sin cambiarla */}
      <Modal isOpen={!!(isAuth && user && user.debeCambiarPassword)} backdrop="static" keyboard={false}>
        <ModalHeader>Cambia tu contraseña</ModalHeader>
        <ModalBody>
          <p style={{ fontSize: 14 }}>
            Tu contraseña es temporal. Para seguir, escribe una nueva que solo tu conozcas
            (minimo 8 caracteres). No la compartas con nadie.
          </p>
          <Password />
        </ModalBody>
      </Modal>
    </AuthContext.Provider>
  )
};

export default AuthContextProvider;